import { memo } from 'react';
import TanStackGrid from '../../../../../components/Table/TanStackGrid';
import type { CustomColumnDef } from '../../../../../components/Table/types';

const EMPTY_SEARCH_ITEMS: never[] = [];

type SummaryMatchGridViewProps = {
  columns: CustomColumnDef[];
  matchedRows: Record<string, string>[];
  columnVisibilityModel: Record<string, boolean>;
  columnOrder: string[];
  onColumnVisibilityModelChange: (model: Record<string, boolean>) => void;
  onColumnOrderChange: (order: string[]) => void;
};

function SummaryMatchGridView({
  columns,
  matchedRows,
  columnVisibilityModel,
  columnOrder,
  onColumnVisibilityModelChange,
  onColumnOrderChange,
}: SummaryMatchGridViewProps) {
  return (
    <div className="summary-match-modal-grid-host">
      <TanStackGrid
        embedded
        columns={columns}
        data={matchedRows}
        pagination={false}
        manualSorting={false}
        loading={false}
        showFilters={false}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={onColumnVisibilityModelChange}
        columnOrder={columnOrder}
        onColumnOrderChange={onColumnOrderChange}
        isAuthenticated
        searchItems={EMPTY_SEARCH_ITEMS}
      />
    </div>
  );
}

export default memo(SummaryMatchGridView);
